"use strict";

import Dom from "common/Dom";
import * as handlers from "components/Overlay/handlers.js";
var lastFocus;
var modalOpened;
var productModal = $(Dom.productModal);
var productModalImage = $(Dom.productModalImage);
var productModalClose = $(Dom.productModalClose);
export const checkForVideo = function checkForVideo(
  event,
  slick,
  currentSlide,
  nextSlide,
) {
  var currentSlideObj = slick.$slides[currentSlide];
  var $currentVideoSlide = $(currentSlideObj).find(
    ".product-single__media[data-video-slide]",
  );
  if ($currentVideoSlide.length > 0) {
    $currentVideoSlide.children("video")[0].pause();
  }
};
export const openProductModal = function openProductModal($this) {
  var modalIndex = parseInt($this.attr("data-index")); //Finds index of product image to from data-index="{{ forloop.index0 }}"
  var imgSrc = window.productImageArray[modalIndex]; //Pulls cooresponding product image
  var imgAlt = window.productImageAltArray[modalIndex]; //Pulls cooresponding product image alt

  lastFocus = document.activeElement; //Stores focused element before modal opens
  modalOpened = true;
  productModal.addClass("is-active");
  productModalImage.attr("src", imgSrc); //Applies cooresponding product image
  productModalImage.attr("alt", imgAlt); //Applies cooresponding product image alt

  $(document).on("keydown", function (event) {
    if (event.which === 9 && modalOpened) {
      productModalClose.attr("tabindex", "-1");
      if (event.shiftKey) {
        event.preventDefault();
        productModalClose.focus();
      } else if (!event.shiftKey) {
        event.preventDefault();
        productModalClose.focus();
      }
    }
    if (event.which === 27 && modalOpened) {
      closeProductModal();
    }
  });
  handlers.showOverlay();
};
export const closeProductModal = function closeProductModal() {
  modalOpened = false;
  productModal.removeClass("is-active");
  handlers.hideOverlay();
  if (!modalOpened) {
    lastFocus.focus(); // Return focus to the last focused element before modal opened
  }
};
